import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretRight = () => {
  return (
    <g>
      <path d="M4 13.254c.001.19.088.38.26.526.316.267.81.29 1.158.073l.1-.073L11.74 8.53l.086-.084a.66.66 0 0 0-.007-.901l-.08-.076L5.523 2.22l-.1-.073a1.024 1.024 0 0 0-1.058 0l-.1.073-.085.084a.674.674 0 0 0-.175.446H4v10.504z" />
    </g>
  );
};

export default withIcon(IconCaretRight);
